// JavaScript Document

// ---- header02 の位置調整 ----
function setHeader02Top() {
  const header01 = document.querySelector('.shopify-section--announcement-bar');
  const header02 = document.querySelector('.shopify-section--header');
  if (!header01 || !header02) return;

  const h1 = header01.offsetHeight;
  header02.style.top = h1 + 'px';
}

window.addEventListener('load', setHeader02Top);
window.addEventListener('resize', setHeader02Top);

// ---- スムーススクロール（アンカークリック時の補正）----
function getHeadersHeight() {
  const h1 = document.querySelector('.shopify-section--announcement-bar')?.offsetHeight || 0;
  const h2 = document.querySelector('.shopify-section--header')?.offsetHeight || 0;
  return h1 + h2;
}

document.addEventListener('click', function(e) {
  const link = e.target.closest('a[href^="#"]');
  if (!link) return;

  const id = link.getAttribute('href');
  if (id.length > 1) {
    const target = document.querySelector(id);
    if (target) {
      e.preventDefault();
      const headerHeight = getHeadersHeight();
      const offset = target.getBoundingClientRect().top + window.scrollY - headerHeight;

      window.scrollTo({
        top: offset,
        behavior: 'smooth'
      });
    }
  }
});

/**
 * 購入ボタン
------------------------------------------------*/
$(window).scroll(function () {
  if ($(this).scrollTop() > 1) {
      $(".c-btn-buy").addClass("show");
  } else {
      $(".c-btn-buy").removeClass("show");
  }
});

/**
 * fadein
------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {

  const fadeTargets = document.querySelectorAll('.js-fade');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-show');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.3
  });

  fadeTargets.forEach(el => observer.observe(el));

});